import * as React from 'react'
import {IUploadPhotosComponentProps} from "./IUploadPhotosComponentProps";
import {IUploadPhotosComponentState} from "./IUploadPhotosComponentState";
import {toast, ToastContainer} from "react-toastify";
import {WithContext as ReactTags} from 'react-tag-input';
import * as gifshot from 'gifshot'
import * as watermark from 'watermarkjs'
import HeaderComponent from "src/components/homeHeader/HeaderComponent";
import MenuComponent from "../menuComponent/MenuComponent";
import FooterComponent from "src/components/footerComponent/FooterComponent";
import Loader from 'react-loader-spinner'
import MagicDropzone from 'react-magic-dropzone';
import {Line} from 'rc-progress';
import icon2 from "../../assets/images/ion2.svg";
import {withRouter} from "react-router-dom";
import {IUploadGifComponentProps} from "../uploadGifComponent/IUploadGifComponentProps";
import * as gifActions from "../../actions/gifAction";
import {connect} from "react-redux";
import icon3 from "../../assets/images/Group.svg";
import MenuLeftemobile from "../menuLeftMobile/MenuLeftemobile";
import * as modalActions from "../../actions/modalActions";


class UploadPhotosComponent extends React.Component<IUploadPhotosComponentProps, IUploadPhotosComponentState> {


    constructor(props: IUploadPhotosComponentProps) {
        super(props)
        this.state = {
            value: "image/jpeg, image/png, .jpg, .jpeg, .png  ",
            previews: [],
            accepted: [],
            img: '',
            interval: 0.1,
            seek: 0,
            offset: 0,
            numFrames: 0,
            type: '',
            percent: 0,
            youtube: '',
            title: '',
            description: '',
            tags: [],
            uploaded: false,
            text:''
        }
    }

    KeyCodes = {
        comma: 188,
        enter: 13,
    };

    delimiters = [this.KeyCodes.comma, this.KeyCodes.enter];

    handleDelete = (i) => {
        const {tags} = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition = (tag) => {
        tag.text = '#' + tag.text
        if (this.state.tags.filter(t => t.text === tag.text) == 0)
       this.setState(state => ({tags: [...state.tags, tag]}));
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags: newTags});
    }

    async onSubmit () {
        console.log(this.state)
        if (this.props.authenticated  && this.state.tags.length > 0) {
            event.preventDefault()
            this.setState({uploaded: true})

            fetch(this.state.img)
                .then(res => res.blob())
                .then(blob => this.props.handleSubmit(this.props.user, this.state.tags, this.state.title, this.state.description, blob,this.state.text,
                    (key) => {
                        this.props.history.push('/gif/' + key)
                        this.setState({uploaded: false})
                    }))

            console.log(this.state.img)

            await this.props.handleSubmit(this.props.user, this.state.tags, this.state.title, this.state.description, this.state.img,this.state.text,
                (key) => {
                    this.props.history.push('/gif/' + key)
                    this.setState({uploaded: false})
                })
        } else {
            if (!this.props.authenticated )

                this.props.openLoginModal(true , ()=>{})

            else if(this.state.tags.length <=0)
                toast.info('Ajouter des tags')        }
    }


    creategif = () => {


        if (this.state.accepted && this.state.accepted[0]) {
            event.preventDefault()
        let waterMark
        (() => {
            waterMark = document.querySelector("#logogif");
        })();

        let video, time, interval: any
        let image: any
        let images = []

        this.state.accepted.map((v, i) => {
            images.push(v.preview)
        })

        if (this.state.accepted[0].type.split('/')[0] === 'video') {
            video = images
            image = false

            interval = 0.1
        } else {
            video = false
            image = images

            interval = this.state.interval
        }

        gifshot.createGIF(

            {

                gifWidth: 400,
                gifHeight: 300,
                images: image,
                video: video,
                interval: interval,
                offset: this.state.offset,
                numFrames: this.state.numFrames * 10,
                frameDuration: 0.1,
                fontWeight: 'bold',
                fontSize: '40px',
                fontFamily: 'sans-serif',
                fontColor: '#FFFFFF',
                textAlign: 'center',
                textBaseline: 'bottom',
                sampleInterval: 10,
                numWorkers: 2,
                crossOrigin: "anonymous",
               /* waterMark: waterMark,
                waterMarkXCoordinate: 340,
                waterMarkYCoordinate: 240,
                waterMarkWidth:50,
                waterMarkHeight: 50,
               */ textYCoordinate: 0,
                text: this.state.text,

                progressCallback: (captureProgress) => {
                    this.setState({percent: captureProgress * 100})
                    if (captureProgress * 100 === 100 && this.state.img !== '') {
                        this.setState({percent: 0})
                    }

                },
                completeCallback: (com) => {
                    console.log(com, 'complited')
                },
            }, (obj) => {
                if (!obj.error) {
                    this.setState({img: obj.image, percent: 0})
}
            });
}
    }

    handleChange = () => {
        let text, interval, time, seek, video, youtube, numFrames, title, description, tags: any;

        (() => {
            text = document.querySelector("#text");
            interval = document.querySelector("#interval");
            seek = document.querySelector("#seek-bar");
            video = document.querySelector("#video");
            numFrames = document.querySelector("#numFrames");
            youtube = document.querySelector("#youtube");
            title = document.querySelector("#title");
            description = document.querySelector("#description");
        })();

        console.log('ussss')

        if (text)
{            text = text.value;
}else{

            text= this.state.text
        }

        if (title)
            title = title.value
        if (description)
            description = description.value
        numFrames = 5

        time = 0
        if (interval)
            interval = interval.value
        else
            interval = 0.5;
        this.setState({
            seek: seek,
            text: text,
            interval: interval,
            offset: time,
            numFrames: numFrames,
            title: title,
            description: description,
        });
    }
    onDrop = (accepted, rejected, links) => {

        let acc = accepted.map(v => acc = v)

        if (this.state.accepted.length > 0)
            console.log(this.state.accepted[0].type.split('/')[0])

        if (this.state.accepted.length == 0) {
            let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];

            let newAccepted = [...this.state.accepted, ...accepted.map(v => v), ...links];

            this.setState({
                previews: newPreviews,
                accepted: newAccepted,
                type: acc[0].type.split('/')[0]
            });
        }

        if (this.state.accepted.length > 0 && acc[0].type.includes(this.state.type) && this.state.type !== 'video') {
            let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];

            let newAccepted = [...this.state.accepted, ...accepted.map(v => v), ...links];

            this.setState({
                previews: newPreviews,
                accepted: newAccepted,

            });

        }
        console.log(accepted, 'real 2 ')
        console.log(this.state.type, 'state 2')
    };
    onRemove = (file) => {
        console.log(file)
        let acc = this.state.accepted.filter(a => a !== file)
        this.setState({
            accepted: acc
        })
}

    public render() {

        const {uploaded , img,  percent , interval} = this.state

        return (
            <div>
                <MenuLeftemobile/>
                <HeaderComponent/>
                <MenuComponent/>
                <ToastContainer/>

               { !uploaded ?
                <div className='flex' style={{
                    height: '100%',
                }}>
                    <div style={{
                        marginTop : '-30px',
                        minWidth: '300px',
                        maxWidth: '500px',
                        width:'90%'
                    }}>
                        {
                            img
                                ?
                                <div className='' style={{
                                    position: 'relative',
                                    width:'100%'}}>
                                    <img src={this.state.img} style={{
                                        marginTop: 50,
                                        height: 300
                                    }}/>
                                    <div className="editbtn" style={{cursor: 'pointer'}} onClick={() => this.setState({
                                        img: ''
                                    })}>
                                        <div className="btnIcon ">
                                            <img src={icon3}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                percent > 0 && img === '' ?
                                    <Loader type="Plane" color="#f34c71" height={80} width={80}/> :
                                    <MagicDropzone
                                        style={{
                                            width: '100%',
                                            minHeight : 400,
                                            height: '405',
                                            background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)'
                                        }}
                                        className="Dropzone"
                                        accept={this.state.value}
                                        onDrop={this.onDrop}>
                                        <div className="Dropzone-content">
                                            {this.state.accepted.length && this.state.accepted.length > 0 ? (
                                                this.state.accepted.map((v, i) => (
                                                    <div>
                                                        {
                                                            (
                                                                v && this.state.accepted.length === 1 ?
                                                                    <div key={i} className="Dropzone-img-big"
                                                                         style={{maxWidth:'290px',maxHeight:'322px'}}>

                                                                     <div>
                                                                         <div onClick={() => this.onRemove(v)}
                                                                              style={{
                                                                                 width:'20px',
                                                                                  height:'20px',
                                                                                  backgroundColor: 'rgba(153, 153, 153, 0.74);',
                                                                                  color: 'white',
                                                                                  borderRadius: '50%',
                                                                                  opacity: 1.5,
                                                                                  position:'absolute'
                                                                              }}><p style={{textAlign: 'center'}}>x</p>
                                                                         </div>
                                                                        <img className="Dropzone-img-big"
                                                                             src={v.preview}/>
                                                                     </div>
                                                                     </div> :
                                                                    v ?
                                                                        <div key={i}>

                                                                        <div>
                                                                            <div onClick={() => this.onRemove(v)}
                                                                                 style={{

                                                                                     float: 'right',
                                                                                     backgroundColor: 'rgba(153, 153, 153, 0.74);',
                                                                                     color: 'white',
                                                                                     borderRadius: '40%',
                                                                                     opacity: 1.5,
                                                                                     position:'absolute'
                                                                                 }}><p style={{margin: '5px'}}>x</p>
                                                                            </div>
                                                                            <img className="Dropzone-img"
                                                                                 src={v.preview}/>
                                                                        </div>
                                                                        </div> :
                                                                        null
                                                            )
                                                        }
                                                    </div>

                                                ))
                                            ) : (
                                                "Déposez quelques fichiers sur moi!"

                                            )}
                                        </div>
                                    </MagicDropzone>
                        }
                    </div>
                    <div className="" style={{

                        minWidth: '300px',
                        maxWidth: '500px',
                        width:'90%',
                        minHeight:400 ,
                        maxHeight:470,
                        height : 400


                    }}>


                        {
                            !img ?

                                <form style={{
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
                                    marginTop: '12px' ,
                                    borderRadius : '1.5%',
                                    display : 'flex',
                                    flexDirection : 'column'

                                }}>
                                    <p style={{
                                        fontFamily: 'Gotham_Bold',
                                        lineHeight: 'normal',
                                        fontSize: '150%',
                                        color: 'white',
                                        paddingTop: '4%',
                                        paddingLeft: '21px'
                                    }}>
                                        Paramètres du diaporama
                                    </p>
                                    <p style={{
                                        fontFamily: 'Gotham_Bold',
                                        lineHeight: 'normal',
                                        fontSize: '14.2px',
                                        color: 'white',
                                        paddingLeft: '21px',
                                        width: '100%'

                                    }}>



                                        Ajouter ou supprimer une vidéo et réorganiser pour créer votre diaporama

                                    </p>
                                    <div className="ui input" style={{

                                        width: '90%',
                                        height: '35px',
                                        paddingLeft: '21px',
                                        marginTop: '15px'

                                    }}>
                                        <input
                                            style={{

                                                width: '100%',
                                                height: '100%',
                                                paddingLeft: '21px',

                                            }}

                                            placeholder='Ajouter du texte à afficher sur le GIF' type="text"
                                            value={this.state.text} id='text'
                                            onChange={this.handleChange}/>
                                    </div>
                                    <div style={{
                                            paddingLeft: '21px',
                                            marginTop: '10px'


                                        }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            fontFamily: 'Gotham_Bold',
                                            lineHeight: 'normal',
                                            fontSize: '100%',
                                            color: 'white',
                                            width: '90%',
                                            justifyContent: 'space-between',
                                            marginTop: '10px'

                                        }}>
                                            <p>DURÉE DE L'IMAGE</p>

                                            <div className="ui input" style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                            }}>
                                                <p style={{color:'white'}}>Secondes :</p>
                                                <input type="text"
                                                       value={interval.toString()} min="0.0" max="5.0" step='0.1'
                                                       onChange={this.handleChange}
                                                       style={{
                                                           width: '70px',
                                                           height: '29px'

                                                       }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            paddingLeft: '21px',
                                            marginTop: '10px'
                                        }}
                                    >
                                        <input type="range" style={{
                                        width: '90%',
                                        marginTop: '10px'

                                    }} id="interval" value={this.state.interval} min="0.0" max="5.0"
                                           step='0.1'
                                           onChange={this.handleChange}/>
                                    </div>
                                    <div className="btn"
                                         style={{
                                             float: 'right',
                                             width: '40% ',
                                             paddingRight: '10px',
                                             paddingLeft: '21px',
                                             marginTop: '7px',
                                             cursor: 'pointer',
                                             right:'31px',
                                             left :'50%'

                                         }}
                                         onClick={() => this.creategif()}>
                                        <div className="btnIcon"><img src={icon2}/></div>
                                        <div className="btninsideContainer">
                                            <div className="firstTitle">APERÇU</div>
                                        </div>
                                    </div>
                                    {
                                        percent > 0 && img === '' ?
                                            <div>
                                                <h1 style={{
                                                    width: '60%',
                                                    marginLeft: '45%',
                                                    marginTop: '0%'
                                                }}> {Math.floor(percent)}%
                                                </h1>
                                            </div>
                                            :
                                            null
                                    }
                                </form> :

                                <div
                                    style={{
                                        minWidth: '300px',
                                        maxWidth: '500px',
                                        width:'90%',
                                        minHeight:400 ,
                                        maxHeight:470,
                                        height : 400
                                    }}
                                >

                                <form style={{
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
                                    marginTop: '12px'

                                }}>

                                    <div className="" style={{

                                        width: '90%',
                                        height: '35px',
                                        paddingLeft: '21px',
                                        marginTop: '15px'

                                    }}>
                                        <input
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                paddingLeft: '21px',
                                                marginTop: '25px'
                                            }}
                                            placeholder='Ajouter un titre au GIF' type="text" value={this.state.title}
                                            id='title'
                                            onChange={this.handleChange}/>
                                    </div>

                                    <ReactTags
                                        tags={this.state.tags}
                                        handleDelete={this.handleDelete}
                                        handleAddition={this.handleAddition}
                                        handleDrag={this.handleDrag}
                                        delimiters={this.delimiters}
                                        inline={false}
                                        placeholder={ 'Cliquez sur entrée pour ajouter un nouveau tag'}
                                        classNames={{
                                            remove: 'removeClass2',
                                            tagInput: 'inputTags',
                                            selected: 'selectedClass btn',
                                            tag: 'tagClass'
                                        }}
                                        style={{
                                            marginTop: '40px'
                                        }}
                                    />

                                    <div className="btn"
                                         style={{
                                             width: '80% ',
                                             paddingRight: '10px',
                                             paddingLeft: '21px',
                                             marginLeft: '45px',
                                             marginTop: '25px',
                                             cursor: 'pointer'
                                         }}
                                         onClick={() => this.onSubmit()}>
                                        <div className="btnIcon"><img src={icon2}/></div>
                                        <div className="btninsideContainer">
                                            <div className="firstTitle">PUBLIER</div>
                                        </div>
                                    </div>
                                </form>
                                </div>
                        }
                    </div>
                </div> :
                   <Loader type="Plane" color="#f34c71" height={80} width={80} />
               }
<FooterComponent/>
            </div>);
    }
}

function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        authenticated: state.auth.authenticated,
        user: state.auth.currentUser,
        newGif: state.Gif,
    };
}


const mapDispatchToProps = (dispatch: any, ownProps: IUploadGifComponentProps) => {
    return {
        handleSubmit: (user, tags, title, description, file,text, cb) => dispatch(gifActions.onSubmit(user, tags, title, description, file,text , cb)),
        openLoginModal: (type , cb) => dispatch(modalActions.loginModal(type, cb)),

    }
}

export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(UploadPhotosComponent))






// WEBPACK FOOTER //
// ./src/components/uploadPhotosComponent/uploadPhotosComponent.tsx